// src/data/services.tsx

import { site } from "@/data/default";
import { Service } from "@/types/service";
import JasaPembuatanSoftwareContent from "@/data/services/jasa-pembuatan-software";
import JasaWebDevelopmentContent from "@/data/services/jasa-web-development";
import JasaInstalasiJaringanCCTVContent from "@/data/services/jasa-instalasi-jaringan-cctv";
import JasaInstalasiPanelSuryaContent from "@/data/services/jasa-instalasi-panel-surya";

const services: Service[] = [
  {
    id: 1,
    name: "Software Development",
    title: "Jasa Pembuatan Software",
    description: "Harga Jasa Pembuatan Software",
    newTab: false,
    slug: "jasa-pembuatan-software",
    img: {
      src: "",
      alt: "",
      width: 0,
      height: 0,
    },
    icon: {
      src: "",
      alt: "",
      width: 0,
      height: 0,
    },
    content: JasaPembuatanSoftwareContent,
  },
  {
    id: 2,
    name: "Web Development",
    title: "Jasa Pembuatan Website Murah",
    description: "Harga Jasa Pembuatan Website Murah",
    newTab: false,
    slug: "jasa-pembuatan-website",
    img: {
      src: "",
      alt: "",
      width: 0,
      height: 0,
    },
    icon: {
      src: "",
      alt: "",
      width: 0,
      height: 0,
    },
    content: JasaWebDevelopmentContent,
  },
  {
    id: 3,
    name: "Jaringan & CCTV",
    title: "Jasa Instalasi Jaringan & CCTV",
    description: "Harga Jasa Instalasi Jaringan & CCTV",
    newTab: false,
    slug: "jasa-instalasi-jaringan-cctv",
    img: {
      src: "",
      alt: "",
      width: 0,
      height: 0,
    },
    icon: {
      src: "",
      alt: "",
      width: 0,
      height: 0,
    },
    content: JasaInstalasiJaringanCCTVContent,
  },
  {
    id: 4,
    name: "Panel Surya",
    title: "Jasa Instalasi Panel Surya",
    description: "Harga Jasa Instalasi Panel Surya",
    newTab: false,
    slug: "jasa-instalasi-panel-surya",
    img: {
      src: "",
      alt: "",
      width: 0,
      height: 0,
    },
    icon: {
      src: "",
      alt: "",
      width: 0,
      height: 0,
    },
    content: JasaInstalasiPanelSuryaContent,
  },
];

export default services;